import { TransactionHistoryRequestModel } from "app/based/baseApiModel/baseTransactionHistory/TransactionHistoryRequestModel";

export class TransactionForRefundRequestEntity extends TransactionHistoryRequestModel {
  userRef?: Array<string>;
  provider?: string;

  constructor(data?: Partial<TransactionForRefundRequestEntity>) {
    super();
    this.code = data?.code;
    this.page = data?.page;
    this.limit = data?.limit;
    this.userRef = data?.userRef;
    this.partner = data?.partner;
    this.provider = data?.provider;
  }
}
